import { useState } from 'react';
import { motion } from 'framer-motion';
import { ShoppingCart, Plus, Minus, Heart, Shirt, Check, X, CreditCard, Loader2, Coffee, Sparkles } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { toast } from 'sonner';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Specialty Cups - $25 each
const specialtyCups = [
  {
    id: 'cup-superpower',
    name: "What's Your Superpower?",
    description: 'I Know CPR - Heart Design',
    price: 25,
    image: 'https://customer-assets.emergentagent.com/job_3768ece8-ea61-4509-ba44-1a2ad698e204/artifacts/675b2fub_1CF43A2B-731C-43A8-97B9-E288CF0EAA32%20%281%29.PNG',
  },
  {
    id: 'cup-stop-hearts',
    name: "I Stop Hearts from Stopping",
    description: 'CPR Training Design',
    price: 25,
    image: 'https://customer-assets.emergentagent.com/job_3768ece8-ea61-4509-ba44-1a2ad698e204/artifacts/675b2fub_1CF43A2B-731C-43A8-97B9-E288CF0EAA32%20%281%29.PNG',
  },
  {
    id: 'cup-aed',
    name: "AED Shield",
    description: 'AED Shield Badge Design',
    price: 25,
    image: 'https://customer-assets.emergentagent.com/job_3768ece8-ea61-4509-ba44-1a2ad698e204/artifacts/675b2fub_1CF43A2B-731C-43A8-97B9-E288CF0EAA32%20%281%29.PNG',
  },
  {
    id: 'cup-heartbeat',
    name: "Heart & Cross",
    description: 'Heartbeat Medical Design',
    price: 25,
    image: 'https://customer-assets.emergentagent.com/job_3768ece8-ea61-4509-ba44-1a2ad698e204/artifacts/675b2fub_1CF43A2B-731C-43A8-97B9-E288CF0EAA32%20%281%29.PNG',
  },
  {
    id: 'cup-do-you',
    name: "I Know CPR. Do You?",
    description: 'CPR Training Design',
    price: 25,
    image: 'https://customer-assets.emergentagent.com/job_3768ece8-ea61-4509-ba44-1a2ad698e204/artifacts/675b2fub_1CF43A2B-731C-43A8-97B9-E288CF0EAA32%20%281%29.PNG',
  },
];

const tshirts = [
  // Kids/Adults - $20
  {
    id: 'i-know-cpr',
    name: "I Know CPR",
    description: 'LifeBreath CPR & First Aid Academy',
    price: 20,
    color: 'White',
    category: 'Kids & Adults',
    image: 'https://customer-assets.emergentagent.com/job_3768ece8-ea61-4509-ba44-1a2ad698e204/artifacts/cu7r1n8c_ChatGPT%20Image%20Mar%206%2C%202026%2C%2011_26_09%20AM.png',
  },
  // Kids - $25
  {
    id: 'lifesaver',
    name: "I'm A Lifesaver",
    description: 'Trained to Save Lives - Beach Theme',
    price: 25,
    color: 'Black',
    category: 'Kids',
    image: 'https://customer-assets.emergentagent.com/job_lifebreath/artifacts/wszpnt2r_ChatGPT%20Image%20Mar%204%2C%202026%2C%2005_46_53%20PM.png',
  },
  {
    id: 'cpr-squad',
    name: 'CPR Squad',
    description: 'Ready. Set. Rescue! - Heart Characters',
    price: 25,
    color: 'Navy Blue',
    category: 'Kids',
    image: 'https://customer-assets.emergentagent.com/job_lifebreath/artifacts/wszpnt2r_ChatGPT%20Image%20Mar%204%2C%202026%2C%2005_46_53%20PM.png',
  },
  {
    id: 'rescue-ninja',
    name: 'Certified Rescue Ninja',
    description: 'Trained to Save Lives! - Ninja Theme',
    price: 25,
    color: 'Gray',
    category: 'Kids',
    image: 'https://customer-assets.emergentagent.com/job_lifebreath/artifacts/wszpnt2r_ChatGPT%20Image%20Mar%204%2C%202026%2C%2005_46_53%20PM.png',
  },
  // Adults - $30
  {
    id: 'cpr-heartbeat-black',
    name: "CPR Lifesaver",
    description: 'Heartbeat Design with First Aid Symbol',
    price: 30,
    color: 'Black',
    category: 'Adults',
    image: 'https://customer-assets.emergentagent.com/job_lifebreath/artifacts/yvxn3hq4_ChatGPT%20Image%20Mar%205%2C%202026%2C%2012_36_43%20PM.png',
  },
  {
    id: 'cpr-american-flag',
    name: "CPR American Pride",
    description: 'American Flag CPR Design',
    price: 30,
    color: 'Navy Blue',
    category: 'Adults',
    image: 'https://customer-assets.emergentagent.com/job_lifebreath/artifacts/yvxn3hq4_ChatGPT%20Image%20Mar%205%2C%202026%2C%2012_36_43%20PM.png',
  },
  {
    id: 'cpr-first-responder',
    name: "First Responder",
    description: 'Emergency Response Icons Design',
    price: 30,
    color: 'Gray',
    category: 'Adults',
    image: 'https://customer-assets.emergentagent.com/job_lifebreath/artifacts/yvxn3hq4_ChatGPT%20Image%20Mar%205%2C%202026%2C%2012_36_43%20PM.png',
  },
];

const sizes = ['Youth S', 'Youth M', 'Youth L', 'Adult S', 'Adult M', 'Adult L', 'Adult XL', 'Adult 2XL'];

export default function Shop() {
  const [cart, setCart] = useState([]);
  const [showCart, setShowCart] = useState(false);
  const [selectedSizes, setSelectedSizes] = useState({});

  const addToCart = (shirt) => {
    const size = selectedSizes[shirt.id];
    if (!size) {
      toast.error('Please select a size');
      return;
    }
    
    const existingItem = cart.find(item => item.id === shirt.id && item.size === size);
    if (existingItem) {
      setCart(cart.map(item => 
        item.id === shirt.id && item.size === size 
          ? { ...item, quantity: item.quantity + 1 }
          : item
      ));
    } else {
      setCart([...cart, { ...shirt, size, quantity: 1 }]);
    }
    toast.success(`${shirt.name} (${size}) added to cart!`);
  };

  const removeFromCart = (index) => {
    setCart(cart.filter((_, i) => i !== index));
  };

  const updateQuantity = (index, delta) => {
    setCart(cart.map((item, i) => {
      if (i === index) {
        const newQty = item.quantity + delta;
        return newQty > 0 ? { ...item, quantity: newQty } : item;
      }
      return item;
    }).filter(item => item.quantity > 0));
  };

  const cartTotal = cart.reduce((sum, item) => sum + (item.price * item.quantity), 0);
  const cartCount = cart.reduce((sum, item) => sum + item.quantity, 0);
  const [checkoutLoading, setCheckoutLoading] = useState(false);

  const handleCheckout = async () => {
    if (cart.length === 0) {
      toast.error('Your cart is empty');
      return;
    }
    
    setCheckoutLoading(true);
    
    try {
      // Create order description
      const orderDetails = cart.map(item => {
        if (item.category === 'Cup') {
          return `${item.name} (Cup) x${item.quantity}`;
        }
        return `${item.name} (${item.size}) x${item.quantity}`;
      }).join(', ');
      
      // Create Square payment link
      const response = await axios.post(`${API}/payments/create-link`, {
        booking_id: `merch-${Date.now()}`,
        booking_type: 'merch',
        amount: cartTotal,
        description: `LifeBreath Merch: ${orderDetails}`,
        customer_name: 'Merch Customer',
        customer_email: 'merch@lifebreathcpr.com'
      });
      
      if (response.data?.payment_link_url) {
        toast.success('Redirecting to secure checkout...');
        // Open Square checkout
        window.open(response.data.payment_link_url, '_blank');
        // Clear cart after successful redirect
        setCart([]);
        setShowCart(false);
      }
    } catch (error) {
      console.error('Checkout error:', error);
      // Fallback to SMS if Square fails
      toast.error('Online checkout unavailable. Opening text order instead...');
      const orderDetails = cart.map(item => `${item.name} (${item.size}) x${item.quantity}`).join('\n');
      const message = `Hi! I'd like to order:\n\n${orderDetails}\n\nTotal: $${cartTotal}`;
      const phoneNumber = '9123886305';
      const smsUrl = `sms:${phoneNumber}?body=${encodeURIComponent(message)}`;
      window.location.href = smsUrl;
    } finally {
      setCheckoutLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900">
      {/* Header */}
      <section className="py-12 md:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
            <Badge className="bg-gradient-to-r from-[#c31c31] to-[#5a2b8a] text-white mb-4 text-lg px-4 py-2">
              <Sparkles className="w-4 h-4 mr-1 inline" /> NEW! Limited Edition
            </Badge>
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4" style={{ fontFamily: 'Manrope, sans-serif' }}>
              LifeBreath Merch Shop
            </h1>
            <p className="text-xl text-white/70 mb-6">Show your CPR pride!</p>
            
            {/* Product Categories */}
            <div className="flex flex-wrap justify-center gap-4 mb-6">
              <Badge className="bg-[#c31c31] text-white text-lg px-6 py-3">
                <Shirt className="w-5 h-5 mr-2 inline" /> T-Shirts $20-$30
              </Badge>
              <Badge className="bg-[#5a2b8a] text-white text-lg px-6 py-3">
                <Coffee className="w-5 h-5 mr-2 inline" /> Specialty Cups $25
              </Badge>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Cart Button */}
      <div className="fixed top-24 right-4 z-50">
        <Button 
          onClick={() => setShowCart(!showCart)} 
          className="bg-[#c31c31] hover:bg-[#a51828] rounded-full shadow-xl"
          size="lg"
        >
          <ShoppingCart className="w-5 h-5 mr-2" />
          Cart ({cartCount})
          {cartCount > 0 && <span className="ml-2">${cartTotal}</span>}
        </Button>
      </div>

      {/* Cart Sidebar */}
      {showCart && (
        <motion.div 
          initial={{ x: 300, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          className="fixed right-0 top-0 h-full w-full max-w-md bg-white shadow-2xl z-50 overflow-y-auto"
        >
          <div className="p-6">
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-2xl font-bold text-[#2a2873]">Your Cart</h2>
              <Button variant="ghost" onClick={() => setShowCart(false)}>
                <X className="w-6 h-6" />
              </Button>
            </div>
            
            {cart.length === 0 ? (
              <p className="text-slate-500 text-center py-8">Your cart is empty</p>
            ) : (
              <>
                {cart.map((item, index) => (
                  <div key={index} className="flex items-center gap-4 p-4 bg-slate-50 rounded-lg mb-3">
                    <div className="flex-1">
                      <p className="font-semibold text-[#2a2873]">{item.name}</p>
                      <p className="text-sm text-slate-500">
                        {item.category === 'Cup' ? 'Specialty Cup' : `${item.color} • ${item.size}`}
                      </p>
                      <p className="font-bold text-[#c31c31]">${item.price}</p>
                    </div>
                    <div className="flex items-center gap-2">
                      <Button variant="outline" size="sm" onClick={() => updateQuantity(index, -1)}>
                        <Minus className="w-4 h-4" />
                      </Button>
                      <span className="w-8 text-center font-bold">{item.quantity}</span>
                      <Button variant="outline" size="sm" onClick={() => updateQuantity(index, 1)}>
                        <Plus className="w-4 h-4" />
                      </Button>
                    </div>
                    <Button variant="ghost" size="sm" onClick={() => removeFromCart(index)} className="text-red-500">
                      <X className="w-4 h-4" />
                    </Button>
                  </div>
                ))}
                
                <div className="border-t pt-4 mt-4">
                  <div className="flex justify-between text-xl font-bold mb-4">
                    <span>Total:</span>
                    <span className="text-[#c31c31]">${cartTotal}</span>
                  </div>
                  <Button 
                    onClick={handleCheckout} 
                    className="w-full bg-gradient-to-r from-[#c31c31] to-[#5a2b8a] hover:from-[#a51828] hover:to-[#4a2370] rounded-full" 
                    size="lg"
                    disabled={checkoutLoading}
                  >
                    {checkoutLoading ? (
                      <>
                        <Loader2 className="w-5 h-5 mr-2 animate-spin" /> Processing...
                      </>
                    ) : (
                      <>
                        <CreditCard className="w-5 h-5 mr-2" /> Pay with Square
                      </>
                    )}
                  </Button>
                  <p className="text-xs text-slate-500 text-center mt-2">
                    Secure checkout powered by Square
                  </p>
                </div>
              </>
            )}
          </div>
        </motion.div>
      )}

      {/* T-Shirts Display */}
      <section className="pb-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          
          {/* Kids & Adults - $20 Section */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold text-white text-center mb-2">Kids & Adults</h2>
            <p className="text-white/60 text-center mb-8">Perfect for the whole family!</p>
            <div className="grid md:grid-cols-1 max-w-md mx-auto gap-8">
              {tshirts.filter(s => s.category === 'Kids & Adults').map((shirt, index) => (
                <motion.div key={shirt.id} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: index * 0.1 }}>
                  <Card className="bg-white/10 backdrop-blur-sm border-white/20 overflow-hidden hover:bg-white/20 transition-all">
                    <CardContent className="p-6">
                      <img src={shirt.image} alt={shirt.name} className="w-full h-48 object-cover rounded-lg mb-4" />
                      <div className="flex justify-between items-center mb-2">
                        <Badge className="bg-white text-slate-800">{shirt.color}</Badge>
                        <Badge className="bg-green-500 text-white">${shirt.price}</Badge>
                      </div>
                      <h3 className="text-xl font-bold text-white text-center mb-2">{shirt.name}</h3>
                      <p className="text-white/70 text-center text-sm mb-4">{shirt.description}</p>
                      <div className="mb-4">
                        <label className="text-white/70 text-sm block mb-2">Select Size:</label>
                        <div className="grid grid-cols-4 gap-1">
                          {sizes.map(size => (
                            <button key={size} onClick={() => setSelectedSizes({ ...selectedSizes, [shirt.id]: size })}
                              className={`p-1 text-xs rounded transition-all ${selectedSizes[shirt.id] === size ? 'bg-[#c31c31] text-white' : 'bg-white/20 text-white hover:bg-white/30'}`}>
                              {size.replace('Adult ', '').replace('Youth ', 'Y')}
                            </button>
                          ))}
                        </div>
                      </div>
                      <Button onClick={() => addToCart(shirt)} className="w-full bg-gradient-to-r from-[#c31c31] to-[#5a2b8a] rounded-full">
                        <Plus className="w-4 h-4 mr-2" /> Add to Cart
                      </Button>
                    </CardContent>
                  </Card>
                </motion.div>
              ))}
            </div>
          </div>

          {/* Kids - $25 Section */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold text-white text-center mb-2">Kids Collection</h2>
            <p className="text-white/60 text-center mb-4">Fun designs for young lifesavers!</p>
            <Badge className="bg-[#c31c31] text-white mx-auto block w-fit mb-8">$25 each</Badge>
            <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} className="mb-8">
              <img src="https://customer-assets.emergentagent.com/job_lifebreath/artifacts/wszpnt2r_ChatGPT%20Image%20Mar%204%2C%202026%2C%2005_46_53%20PM.png"
                alt="Kids CPR T-Shirts Collection" className="w-full max-w-3xl mx-auto rounded-2xl shadow-2xl" />
            </motion.div>
            <div className="grid md:grid-cols-3 gap-8">
              {tshirts.filter(s => s.category === 'Kids').map((shirt, index) => (
                <motion.div key={shirt.id} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: index * 0.1 }}>
                  <Card className="bg-white/10 backdrop-blur-sm border-white/20 overflow-hidden hover:bg-white/20 transition-all">
                    <CardContent className="p-6">
                      <div className="text-center mb-4">
                        <Badge className={`${shirt.color === 'Black' ? 'bg-slate-800' : shirt.color === 'Navy Blue' ? 'bg-blue-800' : 'bg-slate-500'} text-white`}>
                          {shirt.color}
                        </Badge>
                      </div>
                      <h3 className="text-xl font-bold text-white text-center mb-2">{shirt.name}</h3>
                      <p className="text-white/70 text-center text-sm mb-4">{shirt.description}</p>
                      <div className="text-center mb-4">
                        <span className="text-3xl font-bold text-[#c31c31]">${shirt.price}</span>
                      </div>
                      <div className="mb-4">
                        <label className="text-white/70 text-sm block mb-2">Select Size:</label>
                        <div className="grid grid-cols-4 gap-1">
                          {sizes.map(size => (
                            <button key={size} onClick={() => setSelectedSizes({ ...selectedSizes, [shirt.id]: size })}
                              className={`p-1 text-xs rounded transition-all ${selectedSizes[shirt.id] === size ? 'bg-[#c31c31] text-white' : 'bg-white/20 text-white hover:bg-white/30'}`}>
                              {size.replace('Adult ', '').replace('Youth ', 'Y')}
                            </button>
                          ))}
                        </div>
                      </div>
                      <Button onClick={() => addToCart(shirt)} className="w-full bg-gradient-to-r from-[#c31c31] to-[#5a2b8a] rounded-full">
                        <Plus className="w-4 h-4 mr-2" /> Add to Cart
                      </Button>
                    </CardContent>
                  </Card>
                </motion.div>
              ))}
            </div>
          </div>

          {/* Adults - $30 Section */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold text-white text-center mb-2">Adults Collection</h2>
            <p className="text-white/60 text-center mb-4">Professional designs for certified lifesavers!</p>
            <Badge className="bg-[#5a2b8a] text-white mx-auto block w-fit mb-8">$30 each</Badge>
            <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} className="mb-8">
              <img src="https://customer-assets.emergentagent.com/job_lifebreath/artifacts/yvxn3hq4_ChatGPT%20Image%20Mar%205%2C%202026%2C%2012_36_43%20PM.png"
                alt="Adult CPR T-Shirts Collection" className="w-full max-w-3xl mx-auto rounded-2xl shadow-2xl" />
            </motion.div>
            <div className="grid md:grid-cols-3 gap-8">
              {tshirts.filter(s => s.category === 'Adults').map((shirt, index) => (
                <motion.div key={shirt.id} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: index * 0.1 }}>
                  <Card className="bg-white/10 backdrop-blur-sm border-white/20 overflow-hidden hover:bg-white/20 transition-all">
                    <CardContent className="p-6">
                      <div className="text-center mb-4">
                        <Badge className={`${shirt.color === 'Black' ? 'bg-slate-800' : shirt.color === 'Navy Blue' ? 'bg-blue-800' : 'bg-slate-500'} text-white`}>
                          {shirt.color}
                        </Badge>
                      </div>
                      <h3 className="text-xl font-bold text-white text-center mb-2">{shirt.name}</h3>
                      <p className="text-white/70 text-center text-sm mb-4">{shirt.description}</p>
                      <div className="text-center mb-4">
                        <span className="text-3xl font-bold text-[#5a2b8a]">${shirt.price}</span>
                      </div>
                      <div className="mb-4">
                        <label className="text-white/70 text-sm block mb-2">Select Size:</label>
                        <div className="grid grid-cols-4 gap-1">
                          {sizes.map(size => (
                            <button key={size} onClick={() => setSelectedSizes({ ...selectedSizes, [shirt.id]: size })}
                              className={`p-1 text-xs rounded transition-all ${selectedSizes[shirt.id] === size ? 'bg-[#5a2b8a] text-white' : 'bg-white/20 text-white hover:bg-white/30'}`}>
                              {size.replace('Adult ', '').replace('Youth ', 'Y')}
                            </button>
                          ))}
                        </div>
                      </div>
                      <Button onClick={() => addToCart(shirt)} className="w-full bg-gradient-to-r from-[#5a2b8a] to-[#2a2873] rounded-full">
                        <Plus className="w-4 h-4 mr-2" /> Add to Cart
                      </Button>
                    </CardContent>
                  </Card>
                </motion.div>
              ))}
            </div>
          </div>

          {/* Specialty Cups - $25 Section */}
          <div className="mb-16" id="cups">
            <motion.div 
              initial={{ opacity: 0, y: 20 }} 
              animate={{ opacity: 1, y: 0 }}
              className="text-center mb-8"
            >
              <Badge className="bg-gradient-to-r from-yellow-500 to-orange-500 text-white text-lg px-6 py-2 mb-4">
                <Coffee className="w-5 h-5 mr-2 inline" /> NEW ARRIVAL!
              </Badge>
              <h2 className="text-3xl font-bold text-white mb-2">Specialty Tumblers</h2>
              <p className="text-white/60 mb-4">Stay hydrated while showing your CPR pride!</p>
              <Badge className="bg-[#5a2b8a] text-white">$25 each</Badge>
            </motion.div>
            
            {/* Cups Image */}
            <motion.div 
              initial={{ opacity: 0, scale: 0.95 }} 
              animate={{ opacity: 1, scale: 1 }} 
              className="mb-8"
            >
              <img 
                src="https://customer-assets.emergentagent.com/job_3768ece8-ea61-4509-ba44-1a2ad698e204/artifacts/675b2fub_1CF43A2B-731C-43A8-97B9-E288CF0EAA32%20%281%29.PNG"
                alt="LifeBreath CPR Specialty Cups Collection" 
                className="w-full max-w-4xl mx-auto rounded-2xl shadow-2xl"
              />
            </motion.div>
            
            {/* Cup Selection Grid */}
            <div className="grid md:grid-cols-3 lg:grid-cols-5 gap-6">
              {specialtyCups.map((cup, index) => (
                <motion.div 
                  key={cup.id} 
                  initial={{ opacity: 0, y: 20 }} 
                  animate={{ opacity: 1, y: 0 }} 
                  transition={{ delay: index * 0.1 }}
                >
                  <Card className="bg-white/10 backdrop-blur-sm border-white/20 overflow-hidden hover:bg-white/20 transition-all h-full">
                    <CardContent className="p-4 flex flex-col h-full">
                      <div className="bg-gradient-to-r from-yellow-500/20 to-orange-500/20 rounded-lg p-3 mb-3 text-center">
                        <Coffee className="w-10 h-10 text-yellow-400 mx-auto" />
                      </div>
                      <h3 className="text-lg font-bold text-white text-center mb-2">{cup.name}</h3>
                      <p className="text-white/70 text-center text-xs mb-3 flex-grow">{cup.description}</p>
                      <div className="text-center mb-3">
                        <span className="text-2xl font-bold text-yellow-400">${cup.price}</span>
                      </div>
                      <Button 
                        onClick={() => addToCart({ ...cup, color: 'White', category: 'Cup' })} 
                        className="w-full bg-gradient-to-r from-yellow-500 to-orange-500 hover:from-yellow-600 hover:to-orange-600 rounded-full text-sm"
                      >
                        <Plus className="w-4 h-4 mr-1" /> Add to Cart
                      </Button>
                    </CardContent>
                  </Card>
                </motion.div>
              ))}
            </div>
          </div>

        </div>
      </section>
    </div>
  );
}
